function NotFound() {
  return (<p>Page not found</p>);
}

export default NotFound;
